import {  Card, Col, Divider, Row, Select, Space, Statistic, Table, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import usePage from 'src/hooks/usePage'
import {  getUserJourneyReportMetrics, removeEmptyAttributes, searchAppUsageReport, searchUserJourneyReport } from 'src/api/reports'
import AppUsageReportSearch from './userJourneyReportSearch'
import { mncmccOptions, userType } from 'src/constants'
import { EyeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import UserJourneyReportSearch from './userJourneyReportSearch'
import moment from 'moment'
const { Column } = Table

const UserJourneyReportPage: React.FC = () => {
  const { pageData, onQuery, appendSearchForm, submitSearchForm, queryObj,searchForm } =
    usePage({
      getData:  searchUserJourneyReport,
      searchData: searchUserJourneyReport,
      searchType: 'POST',
    })
   
    const [loading, setLoading] = useState(true)
   
    const selectedAccessLevels = userType?.map(item => item.value) ?? [];
const [metricsData, setMetricsData] = useState<UserJourneyMetricsDto>({
  totalUsersJoin: 0,
  totalUsersJoinPrev: 0,
  totalUsersJoinPct: null,
  usersToFreemium: 0,
  usersToFreemiumPrev: 0,
  usersToFreemiumPct: null,
  usersToPremium: 0,
  usersToPremiumPrev: 0,
  usersToPremiumPct: null,
  });
   type TrendProps = { value?: number | null };

const Trend: React.FC<TrendProps> = ({ value }) => {
  const v = value ?? 0;
  const arrow = v > 0 ? "↑" : v < 0 ? "↓" : "→";
  const color = v > 0 ? "#52c41a" : v < 0 ? "#ff4d4f" : "#aaa";
  const display = Math.abs(v).toFixed(1);
  return (
    <span style={{ color: "#aaa", fontSize: 14 }}>
      % Change vs Last Period
      <span style={{ color, fontSize: 14, fontWeight: 600, marginLeft: 30 }}>
        {arrow} {display}%
      </span>
    </span>
  );
};

           const handlePdfClick = () => {
            appendSearchForm({ buttonAction: 'Generate Pdf' })
            submitSearchForm()
          }
        
          const handleCsvClick = () => {
            appendSearchForm({ buttonAction: 'Generate Csv' })
            submitSearchForm()
          }
           const mncmccMap = Object.fromEntries(
            mncmccOptions.map(({ value, label }) => [value, label])
          );
   const userJourneyMetricsPayload = {
     ...searchForm.current,
    startDate: searchForm.current.startDate 
        ? searchForm.current.startDate 
        : moment().subtract(7, 'days').format('YYYY-MM-DD'),

    endDate: searchForm.current.endDate 
        ? searchForm.current.endDate 
        : moment().format('YYYY-MM-DD'),
        userName: null, 
   }
    useEffect(() => {
         const fetchMetricsData = async () => {
           try {
             const data = await getUserJourneyReportMetrics(removeEmptyAttributes(userJourneyMetricsPayload))
             if (data) {
               setMetricsData(data)
             }
           } catch (error) {
             console.error('Error fetching userJourney metrics:', error)
           }
         }
           fetchMetricsData()
       }, [queryObj])
  return (
    <>
     <UserJourneyReportSearch
              appendSearchForm={appendSearchForm}
              submitSearchForm={submitSearchForm}
            />
            <Row  gutter={25} style={{ marginBottom: '20px'}}>
  <Col span={8}>
    <div className="stats-card-wrap">
      <Card
        style={{
          borderRadius: '10px',
          padding: '1rem',
          color: 'white',
         
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ color: '#ccc', fontSize: '16px' }}>Total Users Join</span>
          <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
            {(metricsData?.totalUsersJoin ?? 0).toLocaleString()}
          </span>
         <Trend value={metricsData?.totalUsersJoinPct} />
        </div>
      </Card>
    </div>
  </Col>

  <Col span={8}>
    <div className="stats-card-wrap">
      <Card
        style={{
          borderRadius: '10px',
          padding: '1rem',
          color: 'white',
          background: '#000',
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ color: '#ccc', fontSize: '16px' }}>Users Converted to Freemium</span>
          <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
            {(metricsData?.usersToFreemium ?? 0).toLocaleString()}
          </span>
         <Trend value={metricsData?.usersToFreemiumPct} />
        </div>
      </Card>
    </div>
  </Col>

  <Col span={8}>
    <div className="stats-card-wrap">
      <Card
        style={{
          borderRadius: '10px',
          padding: '1rem',
          color: 'white',
          background: '#000',
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ color: '#ccc', fontSize: '16px' }}>Users Converted to Premium</span>
          <span style={{ color: '#3A63FF', fontSize: '28px', fontWeight: 700 }}>
           {metricsData?.usersToPremium.toLocaleString()}
          </span>
          <Trend value={metricsData?.usersToPremiumPct} />

        </div>
      </Card>
    </div>
  </Col>
</Row>

      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
  <Col>
    <span style={{fontSize:24 }}>
      Search Results ({pageData.total})
    </span>
  </Col>
  <Col>
    <Select
      placeholder="Export"
      style={{ width: 160 }}
      onSelect={(value) => {
        if (value === 'pdf') {
          handlePdfClick();
        } else if (value === 'csv') {
          handleCsvClick();
        }
      }}
      allowClear
    >
      <Select.Option value="pdf">Export as PDF</Select.Option>
      <Select.Option value="csv">Export as CSV</Select.Option>
    </Select>
  </Col>
</Row>

      <Divider />
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
            onChange: (p,ps) =>{
              appendSearchForm({ buttonAction: '' });
             onQuery({ page: (p - 1).toString(),pageSize: ps.toString() });
            },
          }}
         
         
          
        >
          <Column
            width={120}
            dataIndex="userName"
            title="User Name"
            
          />
         

         <Column
  dataIndex="accessLevel"
  title="User Type"
  render={(text) => {
    const colorStyle: React.CSSProperties = {
      color: 'white',
      textAlign: 'center',
      width: 100,
      display: 'inline-block',
      borderRadius: '4px',
      padding: '0 8px',
    };

   switch (text) {
    case 'FREEMIUM':
      colorStyle.backgroundColor = 'rgba(158, 54, 187, 0.78)'; 
      colorStyle.color = 'rgba(222, 222, 222, 1)';
      break;
    case 'GUEST':
      colorStyle.backgroundColor = 'rgba(54, 187, 156, 0.78)'; 
      colorStyle.color = 'rgba(222, 222, 222, 1)';
      break;
    case 'SUBSCRIBED':
      colorStyle.backgroundColor = 'rgba(187, 54, 132, 0.78)';
      colorStyle.color = 'rgba(222, 222, 222, 1)';
      break;
    default:
      colorStyle.backgroundColor = 'rgba(217, 217, 217, 0.78)';
      colorStyle.color = 'rgba(222, 222, 222, 1)';
                 }
              const displayText = text === 'SUBSCRIBED' ? 'PREMIUM' : text;
                 return <Tag  style={colorStyle}>{displayText}</Tag>
               }}
/>
<Column
           dataIndex="effectiveFrom" title="From Date" 
          />
          <Column
           dataIndex="effectiveTo" title="To Date" 
          />
<Column
            dataIndex="deviceType"
            title="Device"
            
          />

           
          
<Column dataIndex="gender" title="Gender" filters={[
              {
                text: 'Male',
                value: 'MALE',
              },
              {
                text: 'Female',
                value: 'FEMALE',
              },
            ]}
            filterMode="tree"
            onFilter={(value: string, record: any) => record.gender === value} />
           
          <Column dataIndex="providerCountry" title="Country" />
          <Column
  title="Source"
  dataIndex="mncmcc"
  render={(value: string) => mncmccMap[value] || value}
/>

          <Column<{ userName: string }>
                      title="Action"
                      key="url"
                      render={(_, record) => (
                        <Space size="middle">
                          <Link to={`/users/detail/${record.userName}`} className="link-btn">
                            <EyeOutlined />
                          </Link>
                        </Space>
                      )}
                    />
        </Table>
      </DndProvider>
    </>
  )
}

UserJourneyReportPage.displayName = 'UserJourneyReportPage'
export default UserJourneyReportPage
